import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Col, Input } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const fillColumn = { width: '100%', height: '36px', fontSize: '14px' };

//Global Search Bar design usally used on main tables.
// Renders the search box and its Clear button as two grid columns, so it must sit inside an
// antd Row. Each control fills its column; the parent Row sets the widths per breakpoint via
// searchCol / clearCol.
const SearchWithClear = ({
  location,
  history,
  searchFormat = 'searchTerm',
  placeholder = 'Search name',
  searchCol = { xs: 24 },
  clearCol = { xs: 24 },
}) => {
  const params = new URLSearchParams(location.search);
  const searchTerm = params.get(searchFormat);

  const [searchValue, setSearchValue] = useState(searchTerm);
  return (
    <>
      <Col {...searchCol}>
        <Input.Search
          placeholder={placeholder}
          style={fillColumn}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          allowClear
          onSearch={(searchValue) => {
            if (searchTerm) {
              params.delete(searchFormat);
            }
            if (searchValue !== '') {
              params.append(searchFormat, searchValue);
            } else {
              params.delete(searchFormat);
            }
            history.push({
              pathname: location.pathname,
              search: `?${params.toString()}`,
            });
          }}
          defaultValue={searchTerm}
        />
      </Col>
      <Col {...clearCol}>
        <Button
          shape="round"
          style={fillColumn}
          type={'default'}
          onClick={() => {
            setSearchValue('');
            params.delete(searchFormat);
            history.push({
              pathname: location.pathname,
              search: `?${params.toString()}`,
            });
          }}
          disabled={!searchTerm}
          icon={<CloseOutlined />}
        >
          Clear
        </Button>
      </Col>
    </>
  );
};

export default withRouter(SearchWithClear);
